import { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { AppContext } from '../util/AppContext';
import { getConfigValue, isBatchPrintEnabledForProduct } from '../util/getConfigValue';
import { isMarketProductMappingEnabled, isProductInMarket, getMarketIdsForProduct } from '../util/marketProductMapping';
import { focusTypeName } from '../util/constants';
import PropTypes from 'prop-types';

ProductsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    onProductClick: PropTypes.func.isRequired,
    onlySellSheetProducts: PropTypes.bool,
};

export function isProductEnabledForCurrentTerritory(territory, clientProductId){
    //if no territory has been selected, show all products
    if(!territory?.productId){
        return true;
    }
    return territory.productId.includes(clientProductId);
}

export function isProductEnabledForCurrentMarket(appState, clientProductId, useCurrentMarket = true) {
    if (!isMarketProductMappingEnabled(appState)) {
        return true;
    }

    const marketId = useCurrentMarket ? (appState?.market?.id ?? appState?.territory?.marketId) : null;

    if (marketId != null) {
        return isProductInMarket(appState.marketProductMap, marketId, clientProductId);
    }

    return getMarketIdsForProduct(appState.marketProductMap, clientProductId).length > 0;
}

export function ProductsModal({ show, setShow, onProductClick, onlySellSheetProducts }) {
    const [appState, setAppState] = useContext(AppContext);
    
    function filterProducts(productDetail) {
        // outside the sales aid flow the selected market is not meaningful, so only require a mapping to exist
        if (!isProductEnabledForCurrentMarket(appState, productDetail.clientProductId, !!onlySellSheetProducts)) {
            return false;
        }
        // Check if product is enabled for current territory
        if(onlySellSheetProducts && !isProductEnabledForCurrentTerritory(appState?.territory, productDetail.clientProductId)){
            return false;
        }
        if (appState.focus === focusTypeName.HCPs && (appState?.products?.length || 0) > 0) {
            const product = appState?.products?.find(p => p.productId === productDetail.clientProductId)
                return (product && product?.messages?.length > 0);
        }
        if(appState.focus === focusTypeName.Messages) {
            return isBatchPrintEnabledForProduct(appState, productDetail.clientProductId);
        }
        return true;
    }

    const products = onlySellSheetProducts ? appState?.sellSheetProductDetails : appState?.productDetails ;

    return (
        <Modal show={show} onHide={() => setShow(false)} scrollable>
            <Modal.Header className="primary" closeButton>
                <Modal.Title className="type-18">{getConfigValue(appState.config?.ProductModal?.SelectBrand?.Label, appState)?.Value || null}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-group list-group-flush">
                    {products?.filter(filterProducts).map((product, index) => (
                        <li key={index} className="list-group-item border border-0">
                            <button onClick={() => onProductClick(product)} className="btn btn-tile btn-tile-outline d-block w-100 text-center py-3">
                                <img style={{ 'maxWidth': '100%' }} src={product.image} className="" alt={`${product.name} logo`} />
                            </button>
                        </li>
                    ))}
                </ul>
            </Modal.Body>
        </Modal>
    );
}

ProductsModalButton.propTypes = {
    setShowProductsModal: PropTypes.func.isRequired,
    productName: PropTypes.string,
    productImageSource: PropTypes.string,
};

export function ProductsModalButton({ setShowProductsModal, productImageSource, productName }) {
    const [appState, setAppState] = useContext(AppContext);

    return (
        
        <button onClick={() => setShowProductsModal(true)} className="border-0 px-0 bg-transparent text-start d-block w-100" data-bs-toggle="modal" data-bs-target="#selectBrand">
            <div className="border border-dark-subtle card p-2 px-3 d-flex flex-row justify-content-center align-items-center">
                {productImageSource ? (
                    <img style={{ 'maxWidth': '100%' }} src={productImageSource} className="" alt={`${productName} logo`} />
                ) : (
                    <span>{productName}</span>
                )}
            </div>
            <p className="m-0 mt-2 type-12 color-primary text-decoration-underline text-decoration-hover-none">{getConfigValue(appState.config?.ProductModal?.ChangeBrand?.Label, appState)?.Value || null}</p>
        </button>
        
    );
}